import { DistanceUnits, FillStyleOptions, LineStyleOptions } from '../../selectionOptions';

export class BufferConfig {
    public defaultBufferOptions: BufferOptions = {
        distance: 100,
        distanceUnit: DistanceUnits[0].value,
        areaUnit: null,
        fillType: FillStyleOptions[0].value,
        fillColor: '#ff0000',
        outlineType: LineStyleOptions[0].value,
        outlineColor: '#ff0000',
        lineWidth: 2,
        unionResults: false,
        opacity: 0.5
    };
}

export class BufferOptions {
    distance: number | number[];
    distanceUnit: __esri.LinearUnits;
    areaUnit?: __esri.ArealUnits;
    fillType: string;
    fillColor: string | number[];
    outlineType: string;
    outlineColor: string | number[];
    lineWidth: number;
    unionResults?: boolean = false;
    opacity?: number;
}
